import { render, staticRenderFns } from "./PhysioForm.vue?vue&type=template&id=a461d980&scoped=true"
import script from "./PhysioForm.vue?vue&type=script&lang=js"
export * from "./PhysioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a461d980",
  null
  
)

export default component.exports